import Intercom from '@intercom/messenger-js-sdk'

export default defineNuxtRouteMiddleware(async (to, _from) => {
  const { user } = useUser()

  const teamSlug = to.params.teamSlug as string
  const workspaceSlug = to.params.workspace as string

  Intercom({
    app_id: 'p7bfhmyq',
    user_id: user.value?.id, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
    name: user.value?.fullName || '', // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
    email: user.value?.primaryEmailAddress?.toString() || '', // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
    user_hash: await useIntercomHash(),
    created_at: user.value?.createdAt?.getDate(), // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
    hide_default_launcher: true,
    custom_launcher_selector: '#support-launcher',
    current_team: teamSlug,
    current_workspace: workspaceSlug,
  })
})
